import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UploadMaterialComponent } from '@shared/components/upload-material/upload-material.component';
import { CassRefreshDirective } from '@shared/directives/cass-refresh.directive';
import { DragNDropDirective } from '@shared/directives/drag-n-drop.directive';
import { AuthImagePipe } from '@shared/pipes/auth-image.pipe';
import { CassFilterPipe } from '@shared/pipes/cass-filter.pipe';
import { CKEditorModule } from 'ckeditor4-angular';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AngularMaterialModule } from './angular-material.module';
import { AdPreviewComponent } from './components/ad-preview/ad-preview.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { CardSliderComponent } from './components/card-slider/card-slider.component';
import { CkTextEditorComponent } from './components/ck-text-editor/ck-text-editor.component';
import { ContactDetailsComponent } from './components/contact-details/contact-details.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { DisplayDatesListComponent } from './components/display-dates-list/display-dates-list.component';
import { DisplayPlacementComponent } from './components/display-placement/display-placement.component';
import { DisplayProductsListComponent } from './components/display-products-list/display-products-list.component';
import { ImageGalleryDialogComponent } from './components/image-gallery-dialog/image-gallery-dialog.component';
import { IndeterminateCircularProgressIndicatorComponent } from './components/indeterminate-circular-progress-indicator/indeterminate-circular-progress-indicator.component';
import { IndeterminateHorizontalProgressIndicatorComponent } from './components/indeterminate-horizontal-progress-indicator/indeterminate-horizontal-progress-indicator.component';
import { MultiFieldTextEditorComponent } from './components/multi-field-text-editor/multi-field-text-editor.component';
import { OrderIdChipComponent } from './components/order-id-chip/order-id-chip.component';
import { PopupPanelComponent } from './components/popup-panel/popup-panel.component';
import { PriceBreakdownComponent } from './components/price-breakdown/price-breakdown.component';
import { SimpleTextEditorComponent } from './components/simple-text-editor/simple-text-editor.component';
import { TermsAndConditionsDialogComponent } from './components/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { UserAlertDialogComponent } from './components/user-alert-dialog/user-alert-dialog.component';
import { AutofocusDirective } from './directives/auto-focus.directive';
import { CassCurrencyPipe } from './directives/cass-currency.pipe';
import { CassDatePipe } from './directives/cass-date.pipe';
import { CassTimestampPipe } from './directives/cass-timestamp.pipe';
import { ErrorForFormControlNameDirective } from './directives/error-for-form-control-name.directive';
import { ErrorForFormControlDirective } from './directives/error-for-form-control.directive';
import { IndeterminateOverlayProgressIndicatorDirective } from './directives/indeterminate-overlay-progress-indicator.directive';
import { AvatarColoursPipe } from './pipes/avatar-colours.pipe';
import { AvatarTextPipe } from './pipes/avatar-text.pipe';
import { PublicOrSecureImageLoaderPipe } from './pipes/public-or-secure-image-loader.pipe';
import {StickyTableHeaderDirective} from '@shared/directives/sticky-table-header.directive';
import {CassButtonDropdownComponent} from '@shared/components/cass-button-dropdown/cass-button-dropdown.component';

@NgModule({
	declarations: [
		AdPreviewComponent,
		AuthImagePipe,
		AutofocusDirective,
		AvatarColoursPipe,
		AvatarTextPipe,
		CalendarComponent,
		CardSliderComponent,
		CassCurrencyPipe,
		CassDatePipe,
		CassFilterPipe,
		CassRefreshDirective,
		CassTimestampPipe,
		CkTextEditorComponent,
		ContactDetailsComponent,
		DialogComponent,
		DisplayDatesListComponent,
		DisplayPlacementComponent,
		DisplayProductsListComponent,
		DragNDropDirective,
		ErrorForFormControlDirective,
		ErrorForFormControlNameDirective,
		ImageGalleryDialogComponent,
		IndeterminateCircularProgressIndicatorComponent,
		IndeterminateHorizontalProgressIndicatorComponent,
		IndeterminateOverlayProgressIndicatorDirective,
		MultiFieldTextEditorComponent,
		OrderIdChipComponent,
		PopupPanelComponent,
		PriceBreakdownComponent,
		PublicOrSecureImageLoaderPipe,
		SimpleTextEditorComponent,
		TermsAndConditionsDialogComponent,
		ToolbarComponent,
		UploadMaterialComponent,
		UserAlertDialogComponent,
		StickyTableHeaderDirective,
		CassButtonDropdownComponent
	],
	imports: [
		AngularMaterialModule,
		BrowserModule,
		CKEditorModule,
		CommonModule,
		FormsModule,
		ImageCropperModule,
		ReactiveFormsModule,
		RouterModule,
		TranslateModule
	],
	exports: [
		AdPreviewComponent,
		AuthImagePipe,
		AutofocusDirective,
		AvatarColoursPipe,
		AvatarTextPipe,
		CalendarComponent,
		CardSliderComponent,
		CassButtonDropdownComponent,
		CassCurrencyPipe,
		CassDatePipe,
		CassFilterPipe,
		CassRefreshDirective,
		CassTimestampPipe,
		CkTextEditorComponent,
		ContactDetailsComponent,
		DialogComponent,
		DisplayDatesListComponent,
		DisplayPlacementComponent,
		DisplayProductsListComponent,
		DragNDropDirective,
		ErrorForFormControlDirective,
		ErrorForFormControlNameDirective,
		ImageGalleryDialogComponent,
		IndeterminateCircularProgressIndicatorComponent,
		IndeterminateHorizontalProgressIndicatorComponent,
		IndeterminateOverlayProgressIndicatorDirective,
		MultiFieldTextEditorComponent,
		OrderIdChipComponent,
		PopupPanelComponent,
		PriceBreakdownComponent,
		PublicOrSecureImageLoaderPipe,
		SimpleTextEditorComponent,
		ToolbarComponent,
		TranslateModule,
		UploadMaterialComponent,
		StickyTableHeaderDirective,
		CassButtonDropdownComponent
	],
	providers: [
		CassCurrencyPipe,
		CassDatePipe,
		CassTimestampPipe,
		DatePipe
	]
})
export class SharedModule { }
